import { render, staticRenderFns } from "./ModalAddClient.vue?vue&type=template&id=fb1f4b12&"
import script from "./ModalAddClient.vue?vue&type=script&lang=js&"
export * from "./ModalAddClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports